import { useRef } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useModal, useToast } from "@/comn/hooks";
import { useRecoilState, useSetRecoilState } from "recoil";
import { authState, storeState } from "../recoil";
import { useEffect, useState } from "react";
import { defaultStoreState } from "../recoil/storeState";

import { _TEST1234 } from "../config/ApiConfig";


const Idras2Tancis = (props: any) => {

    const navigate = useNavigate();
    const { showToast } = useToast();
    const setStore = useSetRecoilState(storeState);
    const [auth, setAuth] = useRecoilState(authState);

    const login = async () => {
        try {
            let reqAuth = Cookies.get("authorization_tancis") || "";
            let reqRefreshAuth = Cookies.get("refreshauthorization_tancis") || ""

            reqAuth = reqAuth.startsWith("Bearer ") ? reqAuth : "Bearer " + reqAuth;
            reqRefreshAuth = reqRefreshAuth.startsWith("Bearer ") ? reqRefreshAuth : "Bearer " + reqRefreshAuth;

            if (reqAuth) {
                _TEST1234.AUTHORIZATION = reqAuth.startsWith("Bearer ") ? reqAuth.substring(7) : reqAuth;
            }
            if (reqRefreshAuth) {
                _TEST1234.REFRESH_AUTHORIZATION = reqRefreshAuth.startsWith("Bearer ") ? reqRefreshAuth.substring(7) : reqRefreshAuth;
            }
            
            const res = await axios.get(
                `${_TEST1234.PORTAL_API_ORI}/api/v1/ptl/auth/usrInfo`,
                {
                    headers: {
                        "Accept-Language": Cookies.get("lang")?.toUpperCase() || "EN",
                        authorization: reqAuth,
                        refreshauthorization: reqRefreshAuth,
                    }

                },
            );

            const userInfo = res.data.userInfo.content;
            const data = { userInfo, type: userInfo.lgnTp, coUsrYn: userInfo.coUsrYn };

            handleSuccess(data);
        } catch (e) {
            showToast({ content: "IDRAS SSO login failed.", type: "error" });
        }
    }

    const handleSuccess = (data: any) => {
        /** Reset page store (recoil) */
        setStore(defaultStoreState);
        /** Set auth (recoil, session storage) */
        setAuth({ ...data, isSignedIn: true, signedAt: new Date(), isInitialized: true });
        window.sessionStorage.setItem("user-info", JSON.stringify(data));

        /** Show toast */
        showToast({ content: "Sign In" });

        redirectToMain();
    };

    const redirectToMain = () => {
        const ptlPath = "/ptli"
        window.location.href = window.location.origin + "/ptli";
    }

    useEffect(() => {
        login();
    }, []);

    // 로딩 화면
    return (
        <>
            <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-white dark:bg-background">
                <span className="text-primary font-semibold">
                    Connecting from IDRAS to TANCIS...
                </span>
            </div>
        </>
    );
};

export default Idras2Tancis;